import { Alert, Typography } from 'antd'
import { useTranslation } from 'react-i18next'
import type { CashFeedback, CashTone } from './useCashOperation'

/**
 * Tovush → antd `Alert` turi.
 *
 * ⚠️ `refused` QIZIL EMAS. Bu butun jadvaldagi eng muhim qator va u
 * `shared/ui/OperationResultAlert` dagi `PARTIAL` qoidasining aynan
 * takrori: server ANIQ javob bergan holatni "xato" deb ko'rsatish
 * kassirni tugmani qayta bosishga undaydi — pul esa ko'chmagan va
 * ikkinchi urinish ham xuddi shunday rad etiladi. Kerak bo'lgani —
 * boshqa summa yoki depozitni to'ldirish.
 *
 * ⚠️ `partial` ham qizil emas va ham yashil emas: pul KO'CHGAN, ya'ni
 * amalni takrorlash ikki barobar yechilishga olib kelardi.
 */
const ALERT_TYPE: Record<CashTone, 'success' | 'warning' | 'error'> = {
  success: 'success',
  partial: 'warning',
  refused: 'warning',
  error: 'error',
}

const TITLE_KEY: Record<CashTone, string> = {
  success: 'cashdesk.result.successTitle',
  partial: 'cashdesk.result.partialTitle',
  refused: 'cashdesk.result.refusedTitle',
  error: 'cashdesk.result.errorTitle',
}

export function CashFeedbackAlert({
  feedback,
  stepLabel,
  onClose,
}: {
  feedback: CashFeedback | null
  /**
   * QAYSI qadam haqida ekani — birlashgan sotuvda IKKI banner yonma-yon
   * turadi ("Balans to'ldirish: bajarildi", "Paket berish: xato").
   *
   * ⚠️ Usiz ikkalasi ham «Bajarildi» / «Xato» deb boshlanardi va kassir
   * qaysi biri pul haqida ekanini ekrandan bilib ololmasdi — aynan
   * qisman muvaffaqiyat paytida, ya'ni eng muhim daqiqada.
   */
  stepLabel?: string
  onClose?: () => void
}) {
  const { t } = useTranslation()
  if (!feedback) return null

  const title = t(TITLE_KEY[feedback.tone])

  return (
    <Alert
      type={ALERT_TYPE[feedback.tone]}
      showIcon
      closable
      {...(onClose ? { onClose } : {})}
      message={stepLabel ? `${stepLabel} — ${title}` : title}
      description={
        <>
          <div>{feedback.message}</div>
          {feedback.hint ? (
            <Typography.Text type="secondary" style={{ fontSize: 12 }}>
              {feedback.hint}
            </Typography.Text>
          ) : null}
        </>
      }
    />
  )
}
